import { intlLocale } from '@/i18n/constants';
import type {
  AdminDeletionRow,
  ContactSyncDelivery,
  ContactSyncView,
  ResellerAiFeatureUsageRow,
} from '@/api/generated';
import { catalogLabel } from '@/i18n/enumLabel';
import i18n from '@/i18n/i18n';

export type AiFeature = NonNullable<ResellerAiFeatureUsageRow['feature']>;
export type DeletionStatus = NonNullable<AdminDeletionRow['status']>;
export type CrmStatus = NonNullable<ContactSyncView['status']>;
export type DeliveryEvent = NonNullable<ContactSyncDelivery['event']>;
export type DeliveryStatus = NonNullable<ContactSyncDelivery['status']>;

export const AI_FEATURES: readonly AiFeature[] = [
  'IMPORT_MAPPING',
  'CATEGORY_SUGGESTION',
  'ENVELOPE_ANALYSIS',
  'MEETING_SUMMARY',
  'MATCH_SUGGESTION',
  'DOMAIN_SETUP',
  'PAYEE_SUGGESTION',
] as const;

export const CRM_EVENTS: readonly DeliveryEvent[] = [
  'PERSON_SEEN',
  'SUBSCRIBED',
  'TRIAL_ENDING',
  'GUEST_SEAT_STARTED',
  'GUEST_SEAT_ENDED',
  'CANCELLED',
  'SUBSCRIPTION_ENDED',
  'LOCKED',
  'RENEWED',
  'RENEWAL_UPCOMING',
  'ERASED',
  'SHARE_CHANGED',
  'CONNECTOR_CHANGED',
  'SETTINGS_CHANGED',
] as const;

function tr(key: string, options?: Record<string, string | number>): string {
  return options ? i18n.t(key, options) : i18n.t(key);
}

export function featureLabel(feature: AiFeature | undefined): string {
  if (feature === undefined) return tr('settings.unavailable');
  return catalogLabel(i18n.t.bind(i18n), `settings.ai.feature.${feature}`);
}

export function deliveryEventLabel(event: DeliveryEvent | undefined): string {
  if (event === undefined) return tr('settings.unavailable');
  return catalogLabel(i18n.t.bind(i18n), `settings.integrations.event.${event}`);
}

/** Compact grouping for a request or delivery count. Absent is "—", never 0. */
export function formatCountOrDash(value: number | null | undefined, locale: string): string {
  if (value == null) return tr('statements.unavailable');
  return new Intl.NumberFormat(intlLocale(locale)).format(value);
}
